module.exports = __webpack_public_path__ + "static/media/quimico.6ec7521c.jpg";